export type Applicant = {
  id: string
  name: string
  // email: string;
  // phone: string;
  bid: string
  experience: string
  specialization: string
  profileImage?: string
  status: 'Pending' | 'Accepted' | 'Rejected'
  appliedDate: string
  message?: string
}

// export type Job = {
//   id: string;
//   title: string;
//   description: string;
//   requirements: string;
//   sessionFrequency: string;
//   duration: string;
//   budgetRange: string;
//   status: "Active" | "Closed";
//   applicants: Applicant[];
//   createdAt: string;
//   updatedAt: string;
// };

export type Job = {
  id: string
  title: string
  description: string
  requirements: string
  sessionFrequency: string
  duration: string
  budgetRange: string
  status: 'Active' | 'Closed'
  applicants: Applicant[]
  createdAt: string
  updatedAt: string

  // New fields from job creation form
  discipline: string
  modality: string
  goals?: string

  // Scheduling Preferences
  startDatePreferred?: string
  sessionsRequested?: number
  sessionLengthMin?: number
  frequencyPerWeek?: number
  preferredDays?: string[]
  preferredTimeWindows?: string[]
  leadTimeHours?: number

  // Location Details
  serviceAddress?: string
  city?: string
  state?: string
  zip?: string
  telehealthState?: string
  shareExactAddressWith?: string

  // Billing Information
  useInsurance: boolean
  payerName?: string
  memberId?: string
  privatePayBudgetPerSession?: number
  evvRequired: boolean
}

export const initialJobs: Job[] = [
  {
    id: 'J001',
    title: 'Weekly Physical Therapy Sessions',
    description:
      'Need a physical therapist for regular sessions to help with post-surgery recovery and mobility improvement. We are seeking an experienced and compassionate physical therapist to provide regular therapy sessions focused on post-surgery rehabilitation. The primary goals are to support recovery, improve overall mobility, reduce pain, and rebuild strength in the affected areas.',
    requirements:
      'Licensed physical therapist with experience in post-operative care',
    sessionFrequency: '3 times per week',
    duration: '1 month',
    budgetRange: '$80-$120 per session',
    status: 'Active',
    createdAt: '2025-09-01',
    updatedAt: '2025-09-15',

    // New fields from job creation form
    discipline: 'PT',
    modality: 'in_person',
    goals:
      'Improve mobility, reduce pain, rebuild strength in affected areas, and support full recovery process.',

    // Scheduling Preferences
    startDatePreferred: '2025-09-20',
    sessionsRequested: 12,
    sessionLengthMin: 60,
    frequencyPerWeek: 3,
    preferredDays: ['Mon', 'Wed', 'Fri'],
    preferredTimeWindows: ['morning', 'afternoon'],
    leadTimeHours: 24,

    // Location Details
    serviceAddress: '123 Main Street',
    city: 'New York',
    state: 'NY',
    zip: '10001',
    shareExactAddressWith: 'shortlisted',

    // Billing Information
    useInsurance: true,
    payerName: 'Blue Cross Blue Shield',
    memberId: 'BCBS123456789',
    privatePayBudgetPerSession: null,
    evvRequired: true,

    applicants: [
      {
        id: 'A1',
        name: 'John Doe',
        // email: 'john.doe@therapy.com',
        // phone: '(555) 123-4567',
        bid: '$100 per session',
        experience: '5 years',
        specialization: 'Physical Therapy, Rehabilitation',
        status: 'Pending',
        appliedDate: '2025-09-10',
        message:
          'I have extensive experience with post-surgery recovery and would love to help with your rehabilitation journey.',
      },
      {
        id: 'A2',
        name: 'Jane Smith',
        // email: 'jane.smith@therapy.com',
        // phone: '(555) 987-6543',
        bid: '$120 per session',
        experience: '3 years',
        specialization: 'Sports Medicine, Physical Therapy',
        status: 'Pending',
        appliedDate: '2025-09-09',
        message:
          'Specialized in sports injuries and recovery programs. Available for immediate start.',
      },
    ],
  },
  {
    id: 'J002',
    title: 'Occupational Therapy for Senior',
    description:
      'Looking for an occupational therapist to provide in-home therapy for elderly patient with mobility challenges. We are seeking an experienced occupational therapist to help with daily living activities and mobility improvements for an elderly patient.',
    requirements: 'Certified OT with geriatric experience',
    sessionFrequency: '2 times per week',
    duration: '2 months',
    budgetRange: '$70-$100 per session',
    status: 'Closed',
    createdAt: '2025-09-05',
    updatedAt: '2025-09-05',

    // New fields from job creation form
    discipline: 'OT',
    modality: 'in_person',
    goals:
      'Improve ability to perform daily living activities, enhance mobility around the house, and increase independence.',

    // Scheduling Preferences
    startDatePreferred: '2025-09-25',
    sessionsRequested: 16,
    sessionLengthMin: 45,
    frequencyPerWeek: 2,
    preferredDays: ['Tue', 'Thu'],
    preferredTimeWindows: ['morning'],
    leadTimeHours: 48,

    // Location Details
    serviceAddress: '456 Oak Avenue',
    city: 'Boston',
    state: 'MA',
    zip: '02108',
    shareExactAddressWith: 'shortlisted',

    // Billing Information
    useInsurance: false,
    payerName: null,
    memberId: null,
    privatePayBudgetPerSession: 85,
    evvRequired: true,

    applicants: [],
  },
  {
    id: 'J003',
    title: 'Speech Therapy for Child',
    description:
      'Seeking speech therapist for child with articulation difficulties and language development needs.',
    requirements: 'Certified speech therapist with pediatric experience',
    sessionFrequency: '2 times per week',
    duration: '3 months',
    budgetRange: '$90-$130 per session',
    status: 'Active',
    createdAt: '2025-09-10',
    updatedAt: '2025-09-10',

    // New fields from job creation form
    discipline: 'SLP',
    modality: 'hybrid',
    goals:
      'Improve articulation, expand vocabulary, enhance communication skills, and build confidence in social interactions.',

    // Scheduling Preferences
    startDatePreferred: '2025-10-01',
    sessionsRequested: 24,
    sessionLengthMin: 30,
    frequencyPerWeek: 2,
    preferredDays: ['Mon', 'Thu'],
    preferredTimeWindows: ['afternoon'],
    leadTimeHours: 72,

    // Location Details
    serviceAddress: '789 Pine Street',
    city: 'Chicago',
    state: 'IL',
    zip: '60601',
    telehealthState: 'IL',
    shareExactAddressWith: 'shortlisted',

    // Billing Information
    useInsurance: true,
    payerName: 'Aetna',
    memberId: 'AETNA789012',
    privatePayBudgetPerSession: null,
    evvRequired: false,

    applicants: [
      {
        id: 'A3',
        name: 'Michael Johnson',
        // email: 'michael.j@therapy.com',
        // phone: '(555) 456-7890',
        bid: '$110 per session',
        experience: '4 years',
        specialization: 'Pediatric Speech Therapy',
        status: 'Pending',
        appliedDate: '2025-09-12',
        message:
          'I have extensive experience working with children and use play-based therapy approaches to make sessions engaging and effective.',
      },
    ],
  },
  {
    id: 'J004',
    title: 'Physical Therapy Assistant for Ongoing Care',
    description:
      'Need a physical therapist assistant to continue ongoing care and exercise program under supervision.',
    requirements: 'Licensed PTA with experience in ongoing care management',
    sessionFrequency: '1 time per week',
    duration: '6 weeks',
    budgetRange: '$60-$80 per session',
    status: 'Active',
    createdAt: '2025-09-08',
    updatedAt: '2025-09-08',

    // New fields from job creation form
    discipline: 'PTA',
    modality: 'in_person',
    goals:
      'Continue prescribed exercise program, monitor progress, and provide support for ongoing rehabilitation.',

    // Scheduling Preferences
    startDatePreferred: '2025-09-18',
    sessionsRequested: 6,
    sessionLengthMin: 45,
    frequencyPerWeek: 1,
    preferredDays: ['Fri'],
    preferredTimeWindows: ['morning', 'afternoon'],
    leadTimeHours: 24,

    // Location Details
    serviceAddress: '321 Elm Street',
    city: 'San Francisco',
    state: 'CA',
    zip: '94102',
    shareExactAddressWith: 'shortlisted',

    // Billing Information
    useInsurance: true,
    payerName: 'UnitedHealthcare',
    memberId: 'UHC456789012',
    privatePayBudgetPerSession: null,
    evvRequired: true,

    applicants: [
      {
        id: 'A4',
        name: 'David Wilson',
        // email: 'david.wilson@therapy.com',
        // phone: '(555) 234-5678',
        bid: '$70 per session',
        experience: '2 years',
        specialization: 'Physical Therapy Assistance, Rehabilitation',
        status: 'Accepted',
        appliedDate: '2025-09-09',
        message:
          'I have experience working with ongoing care programs and can effectively continue prescribed exercise routines.',
      },
    ],
  },
]
